import { Controller } from "@hotwired/stimulus"

// Toggles between a display element and a form element.
// Wrap both in a single element with data-controller="inline-edit".
// Mark the display element with data-inline-edit-target="display"
// and the form element with data-inline-edit-target="form".
// A click on a button with data-action="inline-edit#show" reveals the form.
// A click on one with data-action="inline-edit#hide" hides it again.
export default class extends Controller {
  static targets = ["display", "form"]

  show() {
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    const input = this.formTarget.querySelector("input, select, textarea")
    if (input) input.focus()
  }

  hide() {
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }
}
